import { makeApiError } from '@infl-ts/util-make-apollo-decoded';
import * as D from '@nll/datum/lib/Datum';
import * as DE from '@nll/datum/lib/DatumEither';
import * as E from 'fp-ts/Either';
import { pipe } from 'fp-ts/function';
export var queryResultToDE = function queryResultToDE(_ref) {
  var data = _ref.data,
      isLoading = _ref.isLoading,
      isRefetching = _ref.isRefetching,
      isError = _ref.isError,
      error = _ref.error;
  if (isError) return pipe(makeApiError(error), function (e) {
    return isRefetching ? D.refresh(E.left(e)) : DE.failure(e);
  });
  if (isLoading) return DE.pending;
  if (data) return isRefetching ? D.refresh(E.right(data)) : DE.success(data);
  return DE.initial;
};